import React from "react";
import { useNavigate } from "react-router-dom";

const WinnerCard = ({
  data,
  index,
  showMore,
  selectedYear,
  selectedCategory,
  selectedProvince,
}) => {
  const navigate = useNavigate();
  const awsurl = "https://eventimages2.s3.ap-south-1.amazonaws.com/winners";
  const imageName = data.image || `${data.name}.jpg`;
  let imageUrl = `${awsurl}/${imageName}`;

  if (selectedYear >= 2024) {
    if (selectedCategory === "higher" || !selectedCategory) {
      imageUrl = `${awsurl}/${selectedYear}/higher-education/${imageName}`;
    } else if (selectedCategory === "general") {
      if (selectedProvince) {
        imageUrl = `${awsurl}/${selectedYear}/general-education/${selectedProvince
          .replace(/\s+/g, "-")
          .toLowerCase()}/${imageName}`;
      } else {
        imageUrl = `${awsurl}/${selectedYear}/general-education/${imageName}`;
      }
    }
  }

  // Temporary flag: set to true when General Education images are uploaded
  const SHOW_GENERAL_EDUCATION_IMAGES = true;
  const shouldShowImage =
    selectedCategory !== "general" || SHOW_GENERAL_EDUCATION_IMAGES;

  return (
    <div
      className="bg-slate-800/60 relative h-auto max-w-[320px] w-full lg:w-[300px] rounded-lg shadow-lg flex flex-row md:flex-col flex-wrap justify-center md:justify-start items-center transition-all border-2 border-slate-800/20 cursor-pointer"
      data-aos="fade-up"
      data-aos-delay={100 + 50 * index}
    >
      <div
        className={`${
          showMore ? "brightness-50" : ""
        } bg-slate-800/60 w-full h-full`}
      >
        <div className="award-icon block absolute z-20 w-10 -right-4 -top-4">
          {(() => {
            switch (data.category) {
              case "Impactful Teaching":
                return (
                  <svg
                    height="40px"
                    width="40px"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                  >
                    <g>
                      <path
                        className="st0 fill-orange-400"
                        d="M306.842,315.552l-2.851,1.522c-15.427,8.218-31.586,12.384-48.028,12.384
                 c-16.392,0-32.525-4.166-47.952-12.384l-2.851-1.522l16.66,99.146h68.364L306.842,315.552z"
                      />
                      <polygon
                        className="st0 fill-orange-400"
                        points="195.816,434.616 175.874,487.582 336.128,487.582 316.186,434.616 	"
                      />
                      <path
                        className="st0 fill-orange-400"
                        d="M421.452,43.222c0.21-5.695,0.35-11.425,0.35-17.213v-1.592H90.2v1.592c0,5.788,0.14,11.518,0.35,17.213H0
                 v23.401c0,102.768,70.767,186.378,157.751,186.378l0.31-0.012c28.552,35.497,62.407,54.258,97.941,54.258
                 c35.742,0,69.781-18.979,98.249-54.247c86.984,0,157.749-83.61,157.749-186.378V43.222H421.452z M283.892,157.605l17.238,53.051
                 l-45.128-32.787l-45.128,32.787l17.236-53.051l-45.128-32.788h55.782l17.238-53.055l17.238,53.055h55.78L283.892,157.605z
                  M48.354,90.02h46.204c5.485,39.992,16.262,77.978,31.25,110.21C85.48,184.962,55.394,142.275,48.354,90.02z M386.194,200.229
                 c14.988-32.224,25.763-70.214,31.25-110.21h46.204C456.608,142.275,426.522,184.962,386.194,200.229z"
                      />
                    </g>
                  </svg>
                );
              case "Educational Innovation":
                return (
                  <svg
                    fill="#F28C28"
                    width="50px"
                    height="50px"
                    viewBox="0 0 512 512"
                    enable-background="new 0 0 512 512"
                    id="Dart"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g>
                      <path d="M242.633,394.779c-79.31,0-143.826-64.529-143.826-143.825c0-79.324,64.516-143.839,143.826-143.839   c79.311,0,143.84,64.516,143.84,143.839c0,29.977-9.234,57.833-24.99,80.9l28.646,27.597c22.28-30.41,35.448-67.916,35.448-108.504   c0-101.514-82.294-183.808-183.808-183.808c-101.514,0-183.808,82.293-183.808,183.808c0,101.514,82.293,183.807,183.808,183.807   c47.778,0,91.294-18.231,123.981-48.113l-30.852-25.456C309.905,382.137,277.721,394.779,242.633,394.779z" />

                      <path d="M332.242,303.686c9.103-15.467,14.33-33.488,14.33-52.731c0-57.522-46.625-104.147-104.133-104.147   c-57.522,0-104.148,46.625-104.148,104.147c0,57.508,46.626,104.134,104.148,104.134c22.818,0,43.923-7.344,61.082-19.793   l-37.05-30.57c-7.138,3.099-15.006,4.828-23.283,4.828c-32.366,0-58.604-26.236-58.604-58.606   c0-32.365,26.239-58.604,58.604-58.604c32.362,0,58.604,26.239,58.604,58.604c0,7.029-1.265,13.755-3.537,19.997L332.242,303.686z" />

                      <path d="M453.709,405.172l-32.604-31.611c0.373-0.549-2.334-1.516-4.999-1.607l-26.233,3.906l-1.658-1.587L283.391,273.285   l0.241-0.271c0.672-0.753,0.605-1.907-0.147-2.579l-0.027-0.024c-0.753-0.672-1.908-0.606-2.579,0.147l-0.268,0.3   c-3.884-2.614-8.93-2.601-12.778-0.096l-24.926-19.23c-0.212-0.164-0.641,0-0.971,0.369l-0.012,0.014   c-0.33,0.37-0.443,0.814-0.256,1.007l21.991,22.62c-1.913,4.063-1.309,8.956,1.672,12.448l-0.268,0.301   c-0.672,0.753-0.605,1.908,0.147,2.579l0.027,0.024c0.753,0.672,1.907,0.605,2.579-0.147l0.242-0.271l112.276,92.641l4.202,3.468   l-2.535-2.091l-0.878,26.063c-0.071,2.126,0.852,4.164,2.497,5.513l34.828,28.551c0.689,0.564,1.723,0.069,1.715-0.821   l-0.261-28.027l13.403,11.062c0.666,0.552,1.501,0.788,2.313,0.725c0.501-0.038,0.986-0.204,1.427-0.47   c0.096-0.057,0.194-0.105,0.284-0.174c0.03-0.023,0.056-0.055,0.085-0.078c0.133-0.107,0.264-0.219,0.381-0.35l0.006-0.006   c0-0.001,0.001-0.001,0.002-0.002l0.041-0.047c0.001-0.001,0.001-0.001,0.001-0.001l0.007-0.007   c0.244-0.274,0.422-0.586,0.557-0.91c0.023-0.057,0.058-0.111,0.078-0.17c0.002-0.006,0.002-0.014,0.005-0.02   c0.132-0.383,0.191-0.785,0.176-1.184c-0.028-0.814-0.358-1.618-0.983-2.219l-8.428-8.109l-4.006-3.859l27.816-2.928   C453.981,406.929,454.367,405.811,453.709,405.172z" />
                    </g>
                  </svg>
                );
              case "Community Engagement":
                return (
                  <svg
                    fill="#F28C28"
                    width="50px"
                    height="50px"
                    viewBox="0 0 800 800"
                    enable-background="new 0 0 800 800"
                    id="GUIDE"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g>
                      <g>
                        <path d="M525.771,214.95c-6.824,0-13.473-3.493-17.212-9.784c-5.333-8.972-11.815-17.299-19.267-24.751    c-23.852-23.851-55.563-36.987-89.293-36.987c-11.046,0-20-8.954-20-20s8.954-20,20-20c44.414,0,86.17,17.296,117.576,48.703    c9.803,9.802,18.338,20.77,25.368,32.598c5.644,9.495,2.521,21.768-6.974,27.411C532.768,214.044,529.246,214.95,525.771,214.95z" />
                      </g>

                      <g>
                        <path d="M400,776.572c-69.375,0-125.814-56.44-125.814-125.814c0-11.046,8.954-20,20-20h84.703c11.046,0,20,8.954,20,20    s-8.954,20-20,20h-62.35c9.035,37.702,43.027,65.814,83.461,65.814c47.318,0,85.815-38.496,85.815-85.814c0-11.046,8.954-20,20-20    s20,8.954,20,20C525.815,720.132,469.375,776.572,400,776.572z" />
                      </g>

                      <g>
                        <path d="M446.367,670.758h-6.645c-11.047,0-20-8.954-20-20s8.953-20,20-20h6.645c11.046,0,20,8.954,20,20    S457.413,670.758,446.367,670.758z" />
                      </g>

                      <g>
                        <path d="M505.815,593.129c-11.046,0-20-8.954-20-20c0-58.323,24.131-121.64,60.046-157.556    c38.962-38.963,60.418-90.764,60.418-145.864c0-55.1-21.456-106.901-60.418-145.862C506.901,84.885,455.1,63.428,400,63.428    s-106.901,21.458-145.861,60.419c-38.962,38.961-60.418,90.763-60.418,145.863c0,55.1,21.456,106.901,60.418,145.864    c31.841,31.842,54.419,85.216,59.133,137.556h112.063l39.419-246.371l-22.659,10.3c-6.697,3.046-14.525,2.167-20.383-2.287    L400,298.262l-21.709,16.509c-5.857,4.453-13.686,5.331-20.383,2.287l-22.66-10.3l31.169,194.809    c1.745,10.907-5.683,21.164-16.589,22.909c-10.909,1.741-21.164-5.683-22.909-16.589l-37.054-231.591    c-1.164-7.273,1.766-14.598,7.623-19.064c5.858-4.466,13.697-5.35,20.402-2.302l45.695,20.771l24.309-18.484    c7.152-5.439,17.057-5.44,24.211,0l24.31,18.484l45.695-20.771c6.706-3.049,14.546-2.163,20.402,2.302    c5.858,4.466,8.786,11.791,7.623,19.064l-47.998,299.992c-1.553,9.703-9.923,16.841-19.749,16.841H294.186    c-11.046,0-20-8.954-20-20c0-46.899-20.326-101.267-48.332-129.272c-46.516-46.517-72.133-108.363-72.133-174.147    c0-65.785,25.617-127.631,72.133-174.146C272.369,49.046,334.215,23.428,400,23.428s127.631,25.618,174.146,72.136    c46.516,46.515,72.133,108.361,72.133,174.146c0,65.784-25.617,127.63-72.133,174.147    c-28.005,28.006-48.331,82.373-48.331,129.272C525.815,584.175,516.861,593.129,505.815,593.129z" />
                      </g>
                    </g>
                  </svg>
                );
              default:
                return (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 32 32"
                    id="award"
                  >
                    <path
                      fill={
                        data.award === "gold"
                          ? "#e99e00"
                          : data.award === "silver"
                            ? "#9ca3af"
                            : data.award === "bronze"
                              ? "#9a3412"
                              : data.award === "emerging educator"
                                ? "#f59e0b" // amber-500
                                : data.award === "lifetime award"
                                  ? "#d97706" // amber-600
                                  : "#9a3412"
                      }
                      d="M27.83 12.2a1.57 1.57 0 0 0 .51-1.36 1.17 1.17 0 0 0-.83-1A1.59 1.59 0 0 0 27 11.19 1.18 1.18 0 0 0 27.83 12.2zM28.44 12.75a1.66 1.66 0 0 0-.59 1.41 1.84 1.84 0 0 0 2-1.89A1.67 1.67 0 0 0 28.44 12.75zM27.6 14.11a1.34 1.34 0 0 0-.39-1.35 1.38 1.38 0 0 0-1.39-.29 1.32 1.32 0 0 0 .38 1.35A1.4 1.4 0 0 0 27.6 14.11zM27.61 15.84a1.9 1.9 0 0 0-.88 1.45A1.79 1.79 0 0 0 28.36 17a1.93 1.93 0 0 0 .88-1.45A1.76 1.76 0 0 0 27.61 15.84zM26.47 17.18a1.51 1.51 0 0 0-.17-1.54 1.45 1.45 0 0 0-1.43-.55A1.51 1.51 0 0 0 25 16.63 1.45 1.45 0 0 0 26.47 17.18zM26.75 19.05a2.2 2.2 0 0 0-1.3 1.38 1.8 1.8 0 0 0 1.75.11 2.2 2.2 0 0 0 1.3-1.38A1.77 1.77 0 0 0 26.75 19.05zM23.89 19.27a1.5 1.5 0 0 0 1.32 1 1.85 1.85 0 0 0 .25-1.75 1.51 1.51 0 0 0-1.33-1A1.82 1.82 0 0 0 23.89 19.27zM25 21.71a2.22 2.22 0 0 0-1.46 1.22 1.69 1.69 0 0 0 1.69.34 2.22 2.22 0 0 0 1.47-1.21A1.72 1.72 0 0 0 25 21.71zM22.7 19.82a1.9 1.9 0 0 0-.48 1.73 1.49 1.49 0 0 0 1.15 1.17A2 2 0 0 0 23.86 21 1.49 1.49 0 0 0 22.7 19.82zM22.55 24.17a2.3 2.3 0 0 0-1.9.76A1.66 1.66 0 0 0 22.15 26a2.3 2.3 0 0 0 1.9-.77A1.67 1.67 0 0 0 22.55 24.17zM19.89 22.89a1.71 1.71 0 0 0 .65 1.73A2.37 2.37 0 0 0 21.7 22.9a1.73 1.73 0 0 0-.65-1.73A2.37 2.37 0 0 0 19.89 22.89zM19.35 25.85a2.49 2.49 0 0 0-2.08.84 1.83 1.83 0 0 0 1.64 1.15A2.55 2.55 0 0 0 21 27 1.83 1.83 0 0 0 19.35 25.85zM18.42 24.46a1.87 1.87 0 0 0-.71-1.9 2.57 2.57 0 0 0-1.28 1.88 1.93 1.93 0 0 0 .71 1.91A2.61 2.61 0 0 0 18.42 24.46zM5 11.19a1.59 1.59 0 0 0-.51-1.36 1.17 1.17 0 0 0-.83 1 1.57 1.57 0 0 0 .51 1.36A1.18 1.18 0 0 0 5 11.19zM4.15 14.16a1.66 1.66 0 0 0-.59-1.41 1.67 1.67 0 0 0-1.45-.48 1.66 1.66 0 0 0 .59 1.41A1.65 1.65 0 0 0 4.15 14.16zM4.4 14.11a1.4 1.4 0 0 0 1.4-.29 1.32 1.32 0 0 0 .38-1.35 1.38 1.38 0 0 0-1.39.29A1.34 1.34 0 0 0 4.4 14.11zM5.27 17.29a1.9 1.9 0 0 0-.88-1.45 1.76 1.76 0 0 0-1.63-.28A1.93 1.93 0 0 0 3.64 17 1.79 1.79 0 0 0 5.27 17.29zM5.53 17.18A1.45 1.45 0 0 0 7 16.63a1.51 1.51 0 0 0 .17-1.54 1.45 1.45 0 0 0-1.43.55A1.51 1.51 0 0 0 5.53 17.18zM6.55 20.43a2.2 2.2 0 0 0-1.3-1.38 1.77 1.77 0 0 0-1.75.11 2.2 2.2 0 0 0 1.3 1.38A1.8 1.8 0 0 0 6.55 20.43zM6.54 18.5a1.85 1.85 0 0 0 .25 1.75 1.5 1.5 0 0 0 1.32-1 1.82 1.82 0 0 0-.24-1.75A1.51 1.51 0 0 0 6.54 18.5zM7 21.71a1.72 1.72 0 0 0-1.7.35 2.22 2.22 0 0 0 1.47 1.21 1.69 1.69 0 0 0 1.69-.34A2.22 2.22 0 0 0 7 21.71zM8.63 22.72a1.49 1.49 0 0 0 1.15-1.17 1.9 1.9 0 0 0-.48-1.73A1.49 1.49 0 0 0 8.14 21 2 2 0 0 0 8.63 22.72zM11.35 24.93a2.3 2.3 0 0 0-1.9-.76 1.67 1.67 0 0 0-1.5 1 2.3 2.3 0 0 0 1.9.77A1.66 1.66 0 0 0 11.35 24.93zM11.46 24.62a1.71 1.71 0 0 0 .65-1.73A2.37 2.37 0 0 0 11 21.17a1.73 1.73 0 0 0-.65 1.73A2.37 2.37 0 0 0 11.46 24.62zM11 27a2.55 2.55 0 0 0 2.09.85 1.83 1.83 0 0 0 1.64-1.15 2.49 2.49 0 0 0-2.08-.84A1.83 1.83 0 0 0 11 27zM14.29 22.56a1.87 1.87 0 0 0-.71 1.9 2.61 2.61 0 0 0 1.28 1.89 1.93 1.93 0 0 0 .71-1.91A2.57 2.57 0 0 0 14.29 22.56zM24.11 12A8.11 8.11 0 1 0 16 20.11 8.12 8.12 0 0 0 24.11 12zm-5.37 4L16 14.56 13.26 16 13.79 13l-2.22-2.16 3.06-.45L16 7.57l1.37 2.77 3.06.45L18.21 13z"
                    ></path>
                  </svg>
                );
            }
          })()}
        </div>
        {shouldShowImage ? (
          <img
            src={imageUrl}
            alt={data.name}
            className="w-full h-[200px] rounded-t-lg object-cover object-top"
          />
        ) : (
          <div className="w-full h-[200px] rounded-t-lg bg-slate-700/50 flex flex-col items-center justify-center border-b-2 border-slate-600">
            <span className="text-slate-400 font-medium tracking-wide">
              Image Coming Soon
            </span>
          </div>
        )}
        <div className="winner-content p-4 flex flex-col items-center">
          <h2 className="text-white text-center font-medium text-lg lg:text-xl md:min-h-14">
            {data.name || "Name not found"}
          </h2>
          <h4 className="text-gray-400 text-center font-medium text-sm lg:text-base my-4 px-4 py-1 w-fit bg-gray-800/80">
            {data.category}
          </h4>
          <p className="text-center text-sm font-normal text-gray-400">
            <b>{data.description?.split(".")[0]?.split(",")[0]}</b>
            <br />
            {data.description?.split(".")[0]?.split(",").slice(1).join(",")}
            <br />
            <br />
            <b>{data.description?.split(".")[1]?.split(",")[0]}</b>
            <br />
            {data.description?.split(".")[1]?.split(",").slice(1).join(",")}
          </p>
        </div>
      </div>
      {showMore && (
        <div className="absolute top-2 left-0 w-full h-full flex justify-center items-center font-semibold">
          <button
            onClick={() => navigate("/winners")}
            className="py-2 px-4 bg-orange-600 hover:bg-slate-900 hover:text-orange-400 hover:border-2 hover:border-orange-400 rounded-sm text-white z-20 brightness-100 flex items-center gap-2 transition-all duration-100 group"
          >
            Show More
            <span className=" inline-block transition-transform duration-300 ease-in-out transform group-hover:translate-x-1">
              →
            </span>
          </button>
        </div>
      )}
    </div>
  );
};

export default WinnerCard;
